module.exports = __webpack_public_path__ + "static/media/logo-sut.d4ae375a.png";